/* @ngInject */
const axletreeIcons = () => {
  const self = {}

  self.position = 'train'
  self.decision = 'train'
  self.number = 'train'
  self.weight = 'train'
  self.type = 'train'
  self.diameter = 'train'
  self.material = 'train'
  self.expeditionDate = 'today'
  self.expeditionPlace = 'my_location'
  self.wagonId = 'train'

  return self
}
export default axletreeIcons



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/axletree/resources/icons.resource.js